module.exports = __webpack_public_path__ + "static/media/mindfulness-large.f4b88678.png";